import { format, isValid, parse } from "date-fns";
import { it } from "date-fns/locale";

export const money = (value) =>
  Number(value || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export const formatServiceDate = (value) => {
  if (!value) return "—";

  const raw = String(value);
  const parsed = parse(raw.slice(0, 10), "yyyy-MM-dd", new Date());
  if (!isValid(parsed)) return raw;

  return format(parsed, "d MMM yyyy", { locale: it });
};

// A historical expense without a ledger row is still charged; a ledger row
// counts only while active.
export const isExpenseCharged = (expense) =>
  Number(expense.contabilizzata) === 0 || Number(expense.attivo) === 1;

export const isBudgetConfigured = (budget) =>
  Boolean(budget && Number(budget.budgetEsistente) === 1);

export const getAvailableYears = (budgets, currentYear) => {
  const years = [];

  budgets.forEach((item) => {
    const year = Number(item.anno);
    if (year > 0 && years.indexOf(year) === -1) years.push(year);
  });

  for (let offset = -4; offset <= 4; offset += 1) {
    const candidate = currentYear + offset;
    if (years.indexOf(candidate) === -1) years.push(candidate);
  }

  years.sort((first, second) => second - first);
  return years;
};

export const sortAgentsByLastName = (agents) =>
  agents.slice().sort((first, second) => {
    const lastNameOrder = String(first.lastname || "")
      .toLowerCase()
      .localeCompare(String(second.lastname || "").toLowerCase());
    if (lastNameOrder !== 0) return lastNameOrder;

    return String(first.firstname || "")
      .toLowerCase()
      .localeCompare(String(second.firstname || "").toLowerCase());
  });

export const matchesBudgetExpense = (expense, query, agentName) => {
  const term = String(query || "").trim().toLowerCase();
  if (!term) return true;

  const searchableValues = [agentName, expense.type, expense.titoloEvento, expense.description];
  [expense.dataInizio, expense.dataFine, expense.dateCreated].forEach((value) => {
    if (!value) return;

    const rawDate = String(value);
    const parsedDate = parse(rawDate.slice(0, 10), "yyyy-MM-dd", new Date());
    searchableValues.push(rawDate, formatServiceDate(rawDate));
    if (isValid(parsedDate)) searchableValues.push(format(parsedDate, "MMMM yyyy", { locale: it }));
  });
  [expense.stimaCosto, expense.costo, expense.importo].forEach((value) => {
    if (value === null || typeof value === "undefined" || value === "") return;
    searchableValues.push(String(value), money(value));
  });

  return searchableValues.filter(Boolean).join(" ").toLowerCase().indexOf(term) !== -1;
};

export const matchesBudgetRow = (row, query, agentName) => {
  const term = String(query || "").trim().toLowerCase();
  if (!term) return true;

  const budget = Number(row.importo || 0);
  const spent = Number(row.spese || 0);
  const searchableValues = [agentName, row.anno, String(row.mesiSpesa || "")];
  String(row.mesiSpesa || "").split(",").forEach((monthValue) => {
    const month = Number(monthValue);
    if (month < 1 || month > 12) return;

    const monthDate = new Date(2020, month - 1, 1);
    searchableValues.push(
      String(month),
      format(monthDate, "MMMM", { locale: it }),
      format(monthDate, "MMM", { locale: it }),
    );
  });
  [budget, spent, budget - spent].forEach((value) => {
    searchableValues.push(String(value), money(value));
  });

  return searchableValues.filter(Boolean).join(" ").toLowerCase().indexOf(term) !== -1;
};
